<template>
	<div class="container" @click.self="closeItem">
		<!-- <login-wrap v-if="type == 0" @registShow="registShow" @resetPass="resetPass"></login-wrap>
		<regist-wrap v-else-if="type == 1" @toLogin="loginShow"></regist-wrap>
		<reset-wrap v-else  @toLogin="loginShow"></reset-wrap> -->
		<router-view></router-view>
	</div>
</template>

<script>
import loginWrap from './components/login.vue'
import registWrap from './components/register.vue'
import resetWrap from './components/resetPass.vue'
export default {
  components: {
    loginWrap,
	resetWrap,
	registWrap
  },
  data () {
    return {
      type: 0  //0登录，1注册，2 修改密码
    }
  },
  methods: {
    closeItem(){
    	this.$emit('close',0)
    },
	registShow(val){
		this.type = 1
	},
	resetPass(val){
		this.type = 2
	},
	loginShow(){
		this.type = 0
	}
  },
  mounted () {
    
  }

}
</script>

<style lang="scss" scoped>
.container{
	width: 100vw;
	height: 100vh;
	background: url('../../assets/login-bg.png');
	background-size: 100% 100vh;
	display: flex;  
	justify-content: center; 
	align-items: center;
	padding-top: 50px;
	box-sizing: border-box;
	/* position: fixed;
	top: 0;
	bottom: 0; */
}
/* 针对手机的样式 */
@media (max-width: 767px) {
  .container{
  	width: 100vw;
  	height: calc(100vh - 69px);
	padding-top: 0;
  }
}
</style>